import React from "react";
import { connect } from "react-redux";
import { path } from "ramda";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";
import Colors, { DataVisualizeKeys } from "../../theme/Colors";
import { ReducerKeys } from "../../reducers";
import { isAlive } from "../../util";
import SettingReducer from "../../reducers/SettingReducer";

export const ThemeHelper = {
	/**
     * Get main color from prop.
     * @param {object} props 
     */
	getMainColor(props){
		return path(["theme","mainColor"], props);
	},
	/**
     * Get main visualize color, return main color if nothing found.
     * @param {object} props 
     * @param {number} index 
     * @param {DataVisualizeKeys} type
     */
	getMainVisualizeColor(props, index = 0, type = DataVisualizeKeys.Primary){
		let main = this.getVisualizeFromProp(props,"main",type);
		if(main === undefined){
			main = this.getDefaultVisualize("main",type);
			if(main === undefined){
				main = Colors.mainColor;
			}
		}
		return main[index];
	},
	/**
     * Get color property or whatever in data visualize theme.
     * @param {object} props 
     * @param {array} paths 
     * @param {string} type 
     * @param {object} defaultValue
     */
	getVisualizeFromProp(props, paths, type = DataVisualizeKeys.Primary, defaultValue = undefined){
		const read = path(["theme","data_visualize", type].concat(paths), props);
		if(read === undefined)
			return defaultValue;
		return read;
	},
	/**
     * Get default data visualize value.
     * @param {array} paths 
     * @param {string} type 
     * @param {object} defaultValue 
     */
	getDefaultVisualize(paths, type = DataVisualizeKeys.Primary, defaultValue ){
		const read = path(["data_visualize", type].concat(paths), Colors);
		if(read === undefined)
			return defaultValue;
		return read;
	}
};

function combineTheme(organization, other){
	let theme = Colors;
	if(organization==null){
		return Colors;
	}
	const { color } = organization;
	if(isAlive(color)){
		theme = Object.assign({},Colors, {
			mainColor:color,
			data_visualize: Colors.data_visualize
		});
	}
	return Object.assign({}, theme, other);
}

const state2Props = (state, ownProps)=>{
	const previewTheme = path([ReducerKeys.SETTING,"previewTheme"], state);
	const combine = {
		"theme": combineTheme(path([ReducerKeys.ORGANIZATION,"organization"], state), previewTheme),
	};
	return combine;
};

const prop2Dispatch = (dispatch)=>({
	updatePreviewTheme: previewTheme=>dispatch(SettingReducer.setPreviewTheme(previewTheme)),
	clearPreviewTheme: ()=>dispatch(SettingReducer.clearPreviewTheme())
});

export default (Comp)=>{
	class withThemeProvider extends React.Component{
		updateThemes({mainColor}){
			this.props.updateThemes(mainColor);
		}
		updatePreviewTheme(updateProps){
			this.props.updatePreviewTheme(updateProps);
		}
		clearPreviewTheme(){
			this.props.clearPreviewTheme();
		}
		getChildContext(){
			return {
				updateThemes: this.updateThemes.bind(this),
				updatePreviewTheme: this.updatePreviewTheme.bind(this),
				clearPreviewTheme: this.clearPreviewTheme.bind(this)
			};
		}
        static childContextTypes = {
        	updateThemes: PropTypes.func,
        	updatePreviewTheme: PropTypes.func,
        	clearPreviewTheme: PropTypes.func,
        }
        render(){
        	return <ThemeProvider theme={this.props.theme}>
        		<Comp {...this.props} />
        	</ThemeProvider>;
        }
	}
	return connect(state2Props, prop2Dispatch)(withThemeProvider);
};


// WEBPACK FOOTER //
// ./src/hoc/with/withThemeProvider.js